/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Document data in a text or JSON format.
 */
export type UpdateDocumentRawParamsData = string | { [k: string]: any };

export type UpdateDocumentRawParams = {
  /**
   * Document data in a text or JSON format.
   */
  data: string | { [k: string]: any };
};

/** @internal */
export const UpdateDocumentRawParamsData$inboundSchema: z.ZodType<
  UpdateDocumentRawParamsData,
  z.ZodTypeDef,
  unknown
> = z.union([z.string(), z.record(z.any())]);
/** @internal */
export type UpdateDocumentRawParamsData$Outbound = string | {
  [k: string]: any;
};

/** @internal */
export const UpdateDocumentRawParamsData$outboundSchema: z.ZodType<
  UpdateDocumentRawParamsData$Outbound,
  z.ZodTypeDef,
  UpdateDocumentRawParamsData
> = z.union([z.string(), z.record(z.any())]);

export function updateDocumentRawParamsDataToJSON(
  updateDocumentRawParamsData: UpdateDocumentRawParamsData,
): string {
  return JSON.stringify(
    UpdateDocumentRawParamsData$outboundSchema.parse(
      updateDocumentRawParamsData,
    ),
  );
}
export function updateDocumentRawParamsDataFromJSON(
  jsonString: string,
): SafeParseResult<UpdateDocumentRawParamsData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateDocumentRawParamsData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateDocumentRawParamsData' from JSON`,
  );
}

/** @internal */
export const UpdateDocumentRawParams$inboundSchema: z.ZodType<
  UpdateDocumentRawParams,
  z.ZodTypeDef,
  unknown
> = z.object({
  data: z.union([z.string(), z.record(z.any())]),
});
/** @internal */
export type UpdateDocumentRawParams$Outbound = {
  data: string | { [k: string]: any };
};

/** @internal */
export const UpdateDocumentRawParams$outboundSchema: z.ZodType<
  UpdateDocumentRawParams$Outbound,
  z.ZodTypeDef,
  UpdateDocumentRawParams
> = z.object({
  data: z.union([z.string(), z.record(z.any())]),
});

export function updateDocumentRawParamsToJSON(
  updateDocumentRawParams: UpdateDocumentRawParams,
): string {
  return JSON.stringify(
    UpdateDocumentRawParams$outboundSchema.parse(updateDocumentRawParams),
  );
}
export function updateDocumentRawParamsFromJSON(
  jsonString: string,
): SafeParseResult<UpdateDocumentRawParams, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateDocumentRawParams$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateDocumentRawParams' from JSON`,
  );
}
